export const translations = {
  " import cen": " import cen",
  "< Wróć": "< Wróć",
  "Akcje": "Akcje",
  "Aktualizuj stany": "Aktualizuj stany",
  "Aktywność": "Aktywność",
  "Aktywny": "Aktywny",
  "Aktywny do": "Aktywny do",
  "Aktywowany": "Aktywowany",
  "Anuluj": "Anuluj",
  "Autor": "Autor",
  "Baner...": "Baner...",
  "Banery": "Banery",
  "Biodra": "Biodra",
  "Biust": "Biust",
  "Brak historii zamówień": "Brak historii zamówień",
  "Brak zdjęcia": "Brak zdjęcia",
  "Cancel": "Cancel",
  "Cena": "Cena",
  "Cena do": "Cena do",
  "Cena docelowa": "Cena docelowa",
  "Cena od": "Cena od",
  "Cena przed obniżką": "Cena przed obniżką",
  "Cena przekreślona": "Cena przekreślona",
  "Cena przekreślona do": "Cena przekreślona do",
  "Cena przekreślona od": "Cena przekreślona od",
  "Cena sprzedaży": "Cena sprzedaży",
  "Cena sprzedaży do": "Cena sprzedaży do",
  "Cena sprzedaży od": "Cena sprzedaży od",
  "Cena wyświetlana": "Cena wyświetlana",
  "Cena zakupu": "Cena zakupu",
  "Cena zakupu do": "Cena zakupu do",
  "Cena zakupu netto": "Cena zakupu netto",
  "Cena zakupu od": "Cena zakupu od",
  "Ceny produktu": "Ceny produktu",
  "Czas utworzenia": "Czas utworzenia",
  "Czy na pewno chcesz usunąć stronę?": "Czy na pewno chcesz usunąć stronę?",
  "Dane do wysyłki": "Dane do wysyłki",
  "Dane kontaktowe": "Dane kontaktowe",
  "Data": "Data",
  "Data aktywacji": "Data aktywacji",
  "Data utworzenia": "Data utworzenia",
  "Do daty utworzenia": "Do daty utworzenia",
  "Do sztuk": "Do sztuk",
  "Dodaj": "Dodaj",
  "Dodaj efekt": "Dodaj efekt",
  "Dodaj główną kategorię": "Dodaj główną kategorię",
  "Dodaj kategorię": "Dodaj kategorię",
  "Dodaj kupon": "Dodaj kupon",
  "Dodaj modelkę": "Dodaj modelkę",
  "Dodaj nową modelkę": "Dodaj nową modelkę",
  "Dodaj opinię": "Dodaj opinię",
  "Dodaj produkt": "Dodaj produkt",
  "Dodaj stronę": "Dodaj stronę",
  "Dodaj warunki": "Dodaj warunki",
  "Dostawa": "Dostawa",
  "Dostępne": "Dostępne",
  "Dostępność w przyszłości": "Dostępność w przyszłości",
  "Dzieci": "Dzieci",
  "Dzisiejsza": "Dzisiejsza",
  "EAN": "EAN",
  "ENTER": "ENTER",
  "Edytuj": "Edytuj",
  "Edytuj modelkę": "Edytuj modelkę",
  "Edytuj opinię": "Edytuj opinię",
  "Edytuj wiele produktów": "Edytuj wiele produktów",
  "Eksportuj ceny produktów": "Eksportuj ceny produktów",
  "Element skopiowany do schowka": "Element skopiowany do schowka",
  "Followersów": "Followersów",
  "Forma wysyłki": "Forma wysyłki",
  "Gdzie ma przejść po kliknięciu": "Gdzie ma przejść po kliknięciu",
  "Grupa produktów": "Grupa produktów",
  "Historia": "Historia",
  "Historia (0)": "Historia (0)",
  "Historia (1)": "Historia (1)",
  "Historia sprzedaży": "Historia sprzedaży",
  "Historia zamówień": "Historia zamówień",
  "ID": "ID",
  "ID opinii": "ID opinii",
  "Ilość": "Ilość",
  "Ilość na stanie": "Ilość na stanie",
  "Ilość postów": "Ilość postów",
  "Imię": "Imię",
  "Importuj ceny": "Importuj ceny",
  "Importuj dane z born2be": "Importuj dane z born2be",
  "Indywidualny numer konta do wpłat": "Indywidualny numer konta do wpłat",
  "Informacje o opinii": "Informacje o opinii",
  "Instagram": "Instagram",
  "Język": "Język",
  "Język panelu": "Język panelu",
  "Język treści" : "Język treści",
  "Język dynamicznych treści," : "Język dynamicznych treści,",
  "Język tekstów statycznych" :  "Język tekstów statycznych",
  "Kategoria": "Kategoria",
  "Kategorie": "Kategorie",
  "Kliknij, aby anulować edycję parametrów i modelek": "Kliknij, aby anulować edycję parametrów i modelek",
  "Kliknij, aby edytować kategorie": "Kliknij, aby edytować kategorie",
  "Kliknij, aby edytować parametry i modelki": "Kliknij, aby edytować parametry i modelki",
  "Kliknij, aby edytować zdjęcia": "Kliknij, aby edytować zdjęcia",
  "Kobiety": "Kobiety",
  "Kod": "Kod",
  "Kod Package EAN": "Kod Package EAN",
  "Kod Polski": "Kod Polski",
  "Kod celny": "Kod celny",
  "Kod chiński": "Kod chiński",
  "Kod polski": "Kod polski",
  "Kod produktu": "Kod produktu",
  "Kody chińskie": "Kody chińskie",
  "Kolor": "Kolor",
  "Komfortu": "Komfortu",
  "Koszty wysyłki": "Koszty wysyłki",
  "Kup mniejsze": "Kup mniejsze",
  "Kup większe": "Kup większe",
  "Kupony": "Kupony",
  "Kupony - dodaj": "Kupony - dodaj",
  "Lato": "Lato",
  "Liczba mieszkańców": "Liczba mieszkańców",
  "Liczba postów 12": "Liczba postów 12",
  "Liczba postów 24": "Liczba postów 24",
  "Liczba postów 36": "Liczba postów 36",
  "Liczba postów 48": "Liczba postów 48",
  "Liczba postów 60": "Liczba postów 60",
  "Liczba znaków": "Liczba znaków",
  "Lista kategorii": "Lista kategorii",
  "Lista kuponów": "Lista kuponów",
  "Lista postów": "Lista postów",
  "Lista produktów": "Lista produktów",
  "Lista stron": "Lista stron",
  "Losuj": "Losuj",
  "Marketing": "Marketing",
  "Max Date": "Max Date",
  "Menu": "Menu",
  "Meta keywords": "Meta keywords",
  "Meta description": "Meta description",
  "Miasto": "Miasto",
  "Min Date": "Min Date",
  "Modelki": "Modelki",
  "Models": "Models",
  "Męski": "Męski",
  "Męzczyzni": "Mężczyźni",
  "Mężczyzn": "Mężczyzn",
  'Można łączyć':'Można ł ączyć',
  "Następny": "Następny",
  "Nazwa": "Nazwa",
  "Nazwa pojedyncza": "Nazwa pojedyncza",
  "Nazwa produktu": "Nazwa produktu",
  "Nazwa użytkownika": "Nazwa użytkownika",
  "Nazwa wewnętrzna": "Nazwa wewnętrzna",
  "Nie można łączyć": "Nie można łączyć",
  "Nieaktywny": "Nieaktywny",
  "Niedostępne": "Niedostępne",
  "Nieunikalny": "Nieunikalny",
  "Niezaakceptowane": "Niezaakceptowane",
  "Niezaakceptowany": "Niezaakceptowany",
  "Nijaki": "Nijaki",
  "Nijaki mnogi": "Nijaki mnogi",
  "Notatki": "Notatki",
  "Numer strony": "Numer strony",
  "O autorze": "O autorze",
  "OK": "OK",
  "Obniżenie ceny o %": "Obniżenie ceny o %",
  "Obniżka obecna (%)": "Obniżka obecna (%)",
  "Ocena": "Ocena",
  "Ocena komfortu": "Ocena komfortu",
  "Ocena stylu": "Ocena stylu",
  "Od daty utworzenia": "Od daty utworzenia",
  'Od najmniejszej' : 'Od najmniejszej',
  "Od największej": "Od największej",
  "Od sztuk": "Od sztuk",
  "Odśwież cache": "Odśwież cache",
  "Odśwież linki": "Odśwież linki",
  "Ogólna": "Ogólna",
  "Opinie": "Opinie",
  "Opis kategorii": "Opis kategorii",
  "Opis meta": "Opis meta",
  "Opis produktu": "Opis produktu",
  "Otwórz": "Otwórz",
  "Otwórz wyszukiwarkę": "Otwórz wyszukiwarkę",
  "Package EAN (zablokowane)": "Package EAN (zablokowane)",
  "Parametry": "Parametry",
  "Pełna nazwa": "Pełna nazwa",
  "Pobierz raport cen produktów": "Pobierz raport cen produktów",
  "Podgląd": "Podgląd",
  "Podstawowe info": "Podstawowe info",
  "Poprzedni": "Poprzedni",
  "Pora roku": "Pora roku",
  "Połącz w grupę": "Połącz w grupę",
  "Producent": "Producent",
  "Produkt": "Produkt",
  "Produkty": "Produkty",
  "(produktów, kategorii itp)":"(produktów, kategorii itp)",
  "Przecena do ( % )": "Przecena do ( % )",
  "Przecena od ( % )": "Przecena od ( % )",
  "Przejdź do sklepu": "Przejdź do sklepu",
  "Przenieś niżej": "Przenieś niżej",
  "Przenieś wyżej": "Przenieś wyżej",
  "Przypisz": "Przypisz",
  "Płatność": "Płatność",
  "Razem": "Razem",
  "Raporty": "Raporty",
  "Raporty cen": "Raporty cen",
  "Rodzaj nazwy": "Rodzaj nazwy",
  "Rodzaj przekierowania": "Rodzaj przekierowania",
  'Rozmiar' : "Rozmiar",
  "Rozmiar obuwia": "Rozmiar obuwia",
  "Rozmiarówka": "Rozmiarówka",
  "Sortowanie": "Sortowanie",
  'Stan aktywacji':'Stan aktywacji',
  "Status": "Status",
  "Strony statyczne": "Strony statyczne",
  "Strony statyczne - edycja.":"Strony statyczne - edycja.",
  "Strony statyczne - nowa.":"Strony statyczne - nowa.",
  "Stylu": "Stylu",
  "Submit": "Submit",
  "Suma": "Suma",
  "Szablon": "Szablon",
  "Szczegóły": "Szczegóły",
  "Szczegóły zamówienia": "Szczegóły zamówienia",
  "Szukaj kategorii...": "Szukaj kategorii...",
  "Słowa kluczowe": "Słowa kluczowe",
  "% przeceny": "% Przeceny",
  "Dodaj warunki wielorabatowe": "Dodaj warunki wielorabatowe",
  "Tag": "Tag",
  "Talia": "Talia",
  "Total": "Total",
  "Treść": "Treść",
  "Treść opinii": "Treść opinii",
  "Trwa ładowanie": "Trwa ładowanie",
  "Typ": "Typ",
  "Typ baneru": "Typ baneru",
  "Typowa": "Typowa",
  "Tytuł": "Tytuł",
  "Tytuł linku": "Tytuł linku",
  "Tytuł produktu": "Tytuł produktu",
  "Typ strony":"Typ strony",
  'Unikalny':'Unikalny',
  "Upload": "Upload",
  "Ustaw dzisiejszą": "Ustaw dzisiejszą",
  "Usuń": "Usuń",
  "Usuń modelkę": "Usuń modelkę",
  "Uwaga": "Uwaga",
  "Vices status": "Vices status",
  "Voucher": "Voucher",
  "Wartość": "Wartość",
  "Wartość efektu": "Wartość efektu",
  "Wartość produktów": "Wartość produktów",
  "Ważny do": "Ważny do",
  "Ważny od": "Ważny od",
  "Wgrywanie zdjęć": "Wgrywanie zdjęć",
  "Wiosna/Jesień": "Wiosna/Jesień",
  "Wpisz alt zdjęcia": "Wpisz alt zdjęcia",
  "Wpisz kod celny": "Wpisz kod celny",
  "Wpisz link": "Wpisz link",
  "Wpisz nazwę": "Wpisz nazwę",
  "Wpisz nazwę baneru": "Wpisz nazwę baneru",
  "Wpisz nazwę pojedynczą": "Wpisz nazwę pojedynczą",
  "Wpisz nowy EAN": "Wpisz nowy EAN",
  "Wpisz opis kategorii": "Wpisz opis kategorii",
  "Wpisz opis meta": "Wpisz opis meta",
  "Wpisz słowa kluczowe": "Wpisz słowa kluczowe",
  "Wprowadź ean": "Wprowadź ean",
  "Wprowadź kod": "Wprowadź kod",
  "Wprowadź kody chińskie": "Wprowadź kody chińskie",
  "Wprowadź nazwę": "Wprowadź nazwę",
  "Wprowadź nazwę produktu": "Wprowadź nazwę produktu",
  "Wprowadź nazwę tagu": "Wprowadź nazwę tagu",
  "Wprowadź nazwę użytkownika": "Wprowadź nazwę użytkownika",
  "Wprowadź tag": "Wprowadź tag",
  "Wróć": "Wróć",
  "Wszystkie": "Wszystkie",
  'Wybierz importowane pola':'Wybierz importowane pola',
  "Wybierz jedno z proponowanych słów kluczowych lub wpisz własne i naciśnij": "Wybierz jedno z proponowanych słów kluczowych lub wpisz własne i naciśnij",
  "Wybierz kategorie": "Wybierz kategorie",
  "Wybierz poniżej...": "Wybierz poniżej...",
  "Wybierz...": "Wybierz...",
  "Wybór danego zdjęcia spowoduje natychmiastowe jego wysłanie na nasz serwer! Prosimy upewnić się, czy wrzucany plik na pewno jest prawidłowy.": "Wybór danego zdjęcia spowoduje natychmiastowe jego wysłanie na nasz serwer! Prosimy upewnić się, czy wrzucany plik na pewno jest prawidłowy.",
  "Wyczyść filtry": "Wyczyść filtry",
  "Wyloguj się": "Wyloguj się",
  "Wymiary": "Wymiary",
  "Wyszukaj": "Wyszukaj",
  "Wyszukaj po id opinii": "Wyszukaj po id opinii",
  "Wyszukaj po imieniu": "Wyszukaj po imieniu",
  "Wyszukaj po kodzie produktu": "Wyszukaj po kodzie produktu",
  "Wyszukaj po mieście": "Wyszukaj po mieście",
  "Wzrost": "Wzrost",
  "Zamknij": "Zamknij",
  "Zamknij wyszukiwarkę": "Zamknij wyszukiwarkę",
  "Zamówienia": "Zamówienia",
  "Zamówienie numer": "Zamówienie numer",
  "Zamówienie odrzucone": "Zamówienie odrzucone",
  "Zamówiona ilość": "Zamówiona ilość",
  "Zapisz": "Zapisz",
  "Zapisz zmiany": "Zapisz zmiany",
  "Zatwierdź": "Zatwierdź",
  "Zaznaczonych produktów": "Zaznaczonych produktów",
  "Zdjęcia": "Zdjęcia",
  "Zdjęcie mobile": "Zdjęcie mobile",
  "Zdjęcie modelki": "Zdjęcie modelki",
  "Zdjęcie na desktop": "Zdjęcie na desktop",
  "Zima": "Zima",
  "Zmień": "Zmień",
  "Zmień EAN": "Zmień EAN",
  "Zmień status": "Zmień status",
  "Zmień wszędzie": "Zmień wszędzie",
  "Zobacz": "Zobacz",
  "shipSpeed": "shipSpeed",
  "ubrań": "ubrań",
  "Żeński": "Żeński",
  "Анастасія": "Анастасія",
  "Анна": "Анна",
  "Богуслава": "Богуслава",
  "Ева": "Ева",
  "Любовь": "Любовь",
  "Мирослава": "Мирослава",
  "Наталья": "Наталья",
  "Раиса": "Раиса",
  "Регіна": "Регіна",
  "Соломия": "Соломия",
  "Тетяна": "Тетяна",
  "Ярина": "Ярина",
  "Size": "Rozmiar",
  "Size unified": "Rozmiar zunifikowany",
  "Size code": "Kod rozmiaru",
  "Is Fit":" czy produkt pasował ?",
  "sizing_good": "pasuje",
  "sizing_minus": "za mały",
  "sizing_plus": "za duży"
};



// WEBPACK FOOTER //
// ./locales/pl_PL/translations.js